import { Type } from '@angular/core';
import { isEmpty, isString, matches } from '@sama/micro-dash';
import { isAnnotationOutput } from '../../core/h3ml/dsl/sensor-fusion/sensor-fusion-output.utils';
import { HelpModalComponent } from '../../core/outputs/annotation/annotation-shared/toolbars/static-toolbar/help-modal/help-modal.directive';
import { isOutputWithAnswerOptions } from '../../cross-team-shared/misc-utils/output-utils';
import { Answer } from '../../team-apis/otterdam/answers/answer';
import {
  AbstractOutput,
  AbstractOutputWithAnswerOptions,
} from '../../team-apis/otterdam/outputs/output';

export class OutputHelper<
  OutputType extends AbstractOutput = AbstractOutput,
  AnswerType extends Answer = Answer,
> {
  isMultiFrameOutput = false;
  supportsDefaultAnswer = false;

  getBlankAnswer(output: AbstractOutput): Answer {
    if (isAnnotationOutput(output)) {
      return {};
    }
    return '';
  }

  getHelpModalType(_output: AbstractOutput): Type<HelpModalComponent> {
    throw new Error('Only annotation outputs have a help modal');
  }

  getLabelFor(answer: AnswerType | undefined, _output: OutputType): string {
    if (this.isAnswerBlank(answer)) {
      return '';
    }
    if (!isString(answer)) {
      throw new Error('Override getLabelFor()');
    }
    return answer;
  }

  isAnswerBlank(answer: AnswerType | undefined) {
    return isEmpty(answer);
  }

  makeRandomAnswer(_output: OutputType): AnswerType {
    throw new Error('Override makeRandomAnswer()');
  }

  getMatchingAnswerOptionIds(
    answer: AnswerType | undefined,
    output: AbstractOutput,
  ) {
    if (!isOutputWithAnswerOptions(output)) {
      return [];
    }
    const option = output.answer_options.find(matches({ name: answer }));
    return option ? [option.id] : [];
  }

  getFocusableOutput(
    outputName: string,
    el: HTMLElement | Document,
  ): HTMLElement | null {
    return (
      el.querySelector('.output-tab-content .focusable') ??
      el.querySelector(`h3-output[name="${outputName}"] .focusable`)
    );
  }

  isOrthographicProjection(_output: AbstractOutputWithAnswerOptions) {
    return false;
  }

  protected getMatchingAnswerOptionLabel(
    answer: AnswerType | undefined,
    output: AbstractOutputWithAnswerOptions,
  ) {
    const option = output.answer_options.find(matches({ name: answer }));
    if (option) {
      return option.label || '';
    } else if (answer) {
      return `invalid option: ${answer}`;
    } else {
      return '';
    }
  }
}
